import xssFilter from '~/utils/xss-filter';
import { TicketComment, Message } from './types';
import { MESSAGE_SCHEMA } from './constants';

export const CHAT_TEMPLATE_FILTER = ['_Informasi lainnya', 'Warms Regards,', 'Tim BukaBantuan'];

const parseAgentComment = ({ comment }: { comment: TicketComment }) => {
  const splitBody: string[] = comment.body.split('\n\n');

  const result: Message[] = splitBody.reduce((prev: Message[], chat: string) => {
    if (CHAT_TEMPLATE_FILTER.includes(chat)) return prev;

    const payload = {
      ...MESSAGE_SCHEMA,
      msg: xssFilter(chat),
      timestamp: new Date(comment.created_at).getTime(),
      nick: 'agent',
      displayName: 'agent',
    };
    return [...prev, payload];
  }, [] as Message[]);

  return result;
};

export default parseAgentComment;
